import * as React from 'react';
import cn from 'clsx';
import * as styles from './styles.css';

export enum ENoBorderRadius {
  TopLeft = 'top-left',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
}

export enum ETextareaSkin {
  White = 'white',
  Transparent = 'transparent',
}

export interface ITextareaProps {
  disabled?: boolean;
  noBorderRadius?: ENoBorderRadius;
  skin?: ETextareaSkin;
  placeholder?: string;
  limit?: number;
  value: string;
  onChange(value: string): void;
  onBlur?(event: React.FocusEvent<HTMLTextAreaElement>): void;
}

export const Textarea: React.FC<ITextareaProps> = ({
  disabled,
  placeholder,
  limit,
  skin = ETextareaSkin.White,
  value,
  noBorderRadius,
  onChange,
  onBlur,
}) => {
  const onHandleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;

    if (limit) {
      if (value.length <= limit) {
        onChange(value);
      }

      return;
    }

    onChange(value);
  };

  return (
    <div className={styles['container']}>
      <textarea
        className={cn(styles['textarea'], {
          [styles['white-skin']]: skin === ETextareaSkin.White,
          [styles['transparent-skin']]: skin === ETextareaSkin.Transparent,
          [styles['no-border-top-left-border-radius']]: noBorderRadius === ENoBorderRadius.TopLeft,
          [styles['no-border-top-right-border-radius']]: noBorderRadius === ENoBorderRadius.TopRight,
          [styles['no-border-bottom-left-border-radius']]: noBorderRadius === ENoBorderRadius.BottomLeft,
          [styles['no-border-bottom-right-border-radius']]: noBorderRadius === ENoBorderRadius.BottomRight,
        })}
        placeholder={placeholder}
        value={value}
        onChange={onHandleChange}
        onBlur={onBlur}
        disabled={disabled}
      ></textarea>
      {limit && !disabled && (
        <div className={styles['limit']}>
          {value.length}/{limit}
        </div>
      )}
    </div>
  );
};

Textarea.displayName = 'Textarea';
